'use strict';


export default angular.module('fplTruescapeComApp.passwordMatch', [])

      .directive('passwordMatch', [function() {
        return {
          require: 'ngModel',
          link: (scope, elem, attrs, ctrl) => {
            let password = '#' + attrs.passwordMatch;
            elem.add(password).on('keyup', () => {
              scope.$apply(() => {
                let value = elem.val() === $(password).val();
                ctrl.$setValidity('passwordMatch', value);
              });
            });
          }
        };
      }])
    .name;




// WEBPACK FOOTER //
// ./client/components/directives/passwordMatch/passwordMatch.directive.js